import base from "../../../base";

export default async function fetchUserRepHistory(uid, treeID) {
	const repHistory = base.fetch(`users/${uid}/repHistory/${treeID}`, { context: this });
	return repHistory;
}
